export default () => {
  const $cardAdvertising = $('.rc-card__advertising');
  if($cardAdvertising) {
    $cardAdvertising.each((i, adv) => {
      $(adv).parent().find('.rc-card__header-advertising-icon').on('click', () => {
        $(adv).addClass('open');
      })
      $(adv).find('.rc-card__advertising-close').on('click', () => {
        $(adv).removeClass('open');
      })
    })
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/advertising-block/index.js